import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { TOMOS, TOMO_FEATURES } from './salesData';
export function TomosSection() {
  return <section id="tomos" className="bg-cream py-12 sm:py-16" data-id="element-193" data-mp="1p3k8n3u0t19p">
      <div className="mx-auto max-w-6xl px-5" data-id="element-194" data-mp="1p4c145sbmivr">
        <div className="text-center" data-id="element-195" data-mp="1u36hz26q9xd8">
          <SectionTag data-id="element-196" data-mp="1u2564vhw16ug">Las 6 piezas del sistema</SectionTag>
          <h2 className="mt-3 font-display text-2xl font-black leading-tight text-ink sm:text-4xl" data-id="element-197" data-mp="xcw5xncp7ntx">
            Cada tomo resuelve una parte concreta de tu Instagram
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-ink/70 sm:text-base" data-id="element-198" data-mp="16d2eqvxgbzmr">
            No son libros para leer algún día. Son piezas que aplicás en tu perfil.
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-199" data-mp="1b9sx5pwqb7bc">
          {TOMOS.map(tomo => <article key={tomo.num} className="flex flex-col rounded-2xl border border-rose/10 bg-white p-5 shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md hover:shadow-rose/10" data-id="element-200" data-mp="2mrc2poxs7md2">
              <div className="flex items-center gap-2" data-id="element-201" data-mp="2mnoqaq3c1719">
                <span className="text-2xl" data-id="element-202" data-mp="2hnk6aq37tu6a">{tomo.emoji}</span>
                <p className="text-[0.7rem] font-bold uppercase tracking-widest text-rose" data-id="element-203" data-mp="2hlzbr0gwib8f">
                  {tomo.num}
                </p>
              </div>
              <h3 className="mt-1.5 font-display text-lg font-bold text-ink" data-id="element-204" data-mp="27pwcc2dfoqp6">{tomo.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-ink/75" data-id="element-205" data-mp="22y4i9hv2k2ua">{tomo.outcome}</p>
              <p className="mt-3 border-t border-rose/10 pt-2.5 text-[0.78rem] leading-snug text-ink/55" data-id="element-206" data-mp="1ywsxpqr1y7sy">
                {tomo.desc}
              </p>
            </article>)}
        </div>

        <div id="incluye" className="mt-8 rounded-3xl border border-rose/10 bg-white p-5 shadow-sm sm:p-6" data-id="element-207" data-mp="1oylj3ek8k1u4">
          <h3 className="text-center font-display text-lg font-bold text-ink" data-id="element-208" data-mp="1k139dlye9il2">Cada tomo incluye:</h3>
          <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-209" data-mp="1abefxv0zs85s">
            {TOMO_FEATURES.map(f => <li key={f} className="flex items-start gap-2" data-id="element-210" data-mp="1fcu5o0e472ui">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose" aria-hidden data-id="element-211" data-mp="11bzs73c7mboz" />
                <span className="text-sm leading-snug text-ink/75" data-id="element-212" data-mp="15ctgvyxh7uix">{f}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}